import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
//import { HeaderMenuComponent } from './header-menu/header-menu.component';
import { PreloaderComponent } from './preloader/preloader.component';
//import { Preloader } from '../providers/preloader';

const routes: Routes = [
  { path: 'login',  component: LoginComponent },
  //{ path: 'mainView',  component: HeaderMenuComponent }, //, canActivate: [AuthGuard]
  { path: '', component: PreloaderComponent  }
  //{ path: '', component: LoginComponent }//,
  //{ path: '**', component: PageNotFoundComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {

  
}
